import { createStore, combineReducers, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import expensesReducer from "../reducers/expenses"
import filtersReducer from "../reducers/filters"
import authReducer from "../reducers/auth"
import labelsReducer from "../reducers/labels"
import accountsReducer from "../reducers/accounts"
import importsReducer from "../reducers/imports"
import permissionsReducer from "../reducers/permissions"

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default () => {
  const store = createStore(
    combineReducers({
      expenses: expensesReducer,
      filters: filtersReducer,
      auth: authReducer,
      labels: labelsReducer,
      accounts: accountsReducer,
      imports: importsReducer,
      permissions: permissionsReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))

    //window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )

  return store
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js